module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"energy":"Energie","emissions":"Emissionen","absoluteValues":"Absolut","specificValues":"Spezifisch"}}')
  delete Component.options._Ctor
}
